import { ReactElement } from "react";

import BaseCTAVisual from "@/components/CallToActions/BaseCTAVisual/baseCTAVisual.component";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { CTAActions } from "@/redux/modules/api/data/cart/@types/cart.types";

const changeStoreVisual = (
    product: CartItemModel | null,
    action: CTAActions
): ReactElement => {
    const stores = action.parameters;
    return (
        <>
            {stores.length > 0 && (
                <BaseCTAVisual
                    type={action.type}
                    sku={product?.sku}
                />
            )}
        </>
    );
};

export default changeStoreVisual;
